export function formatNumber(n: number | null | undefined): string {
  return new Intl.NumberFormat("en-US").format(Math.round(n ?? 0));
}

export function formatSeconds(seconds: number | null | undefined): string {
  const total = Math.max(0, seconds ?? 0);
  if (total < 10) return `${Math.round(total * 10) / 10} s`;
  if (total < 60) return `${Math.round(total)} s`;
  const m = Math.floor(total / 60);
  const s = Math.round(total % 60);
  return s === 0 ? `${m}m` : `${m}m ${s}s`;
}

export function formatMs(ms: number | null | undefined): string {
  return formatSeconds((ms ?? 0) / 1000);
}
